import { Route } from "../core/routeGuard/applicationRoutesNg.service";
import { USE_NEW_SIGN_IN_PROCESS } from "./use-new-sign-in-process";

export default class ResetPasswordController {
  email: string;

  /**
   * If the user arrived at the Create A New Password page but the
   * provided code had expired, we end up over here with an indicator of why the failure occurred.
   *
   * @property error
   */
  error: string;

  resetPasswordForm;

  completed: boolean;

  captchaToken;

  resetRecaptcha;

  onUpdateResponseToken(captchaToken: string, resetRecaptcha: object) {
    this.captchaToken = captchaToken;
    // a function provided to allow manually resetting recaptcha
    this.resetRecaptcha = resetRecaptcha;
  }

  constructor($routeParams, private $route, private $location, private $window, private api) {
    'ngInject';

    this.error = $routeParams.error;

    if(USE_NEW_SIGN_IN_PROCESS) {
      this.$window.location.href = Route.RESET_PASSWORD;
    }
  }

  resetPassword(email, form) {
    // Clear the passed in error, if any, so the user can focus on any new errors.
    this.error = '';

    if (email.$valid && this.email && this.captchaToken) {
      this.api.useraccount
        .passwordresetrequests(this.email, this.captchaToken)
        .then(
          () => {
            this.completed = true;
          },
          () => {
            form.$submitted = false;
            this.error = 'captcha';
            this.resetRecaptcha();
          }
        );
    }
  }

  returnToSignIn() {
    this.$location.path('/');
  }
}
